import styled from '@emotion/styled';
import { navigation } from 'src/assets/colors';
import { fontWeight } from 'src/assets/fonts-config';
import { ChevronIcon } from 'src/assets/new-icon/ChevronIcon';
import { easeOpacity } from 'src/domains/layouts/shared/animation/AnimationAndTransition.style';
import Link from 'src/components/Link/Link';

export const ListItemLink = styled(Link, { label: 'ListItemLink' })<TabPropsType>`
    /* stylelint-disable-next-line custom-property-pattern */
    font-family: var(--fontFamilyPrimary);
    background-color: ${({ isActive }): string => isActive ? navigation.bgColorTabActive : 'transparent'} !important;
    border-radius: 4px;
    color: ${({ isActive }): string => isActive ? navigation.txtColorActive : navigation.txtColor};
    cursor: pointer;
    display: block;
    font-size: 14px;
    font-weight: ${({ isActive }): string => isActive ? fontWeight.medium : fontWeight.regular};
    overflow: hidden;
    padding: 5px 28px 5px 8px;
    position: relative;
    text-decoration: none;
    text-overflow: ellipsis;
    transition: color .2s ease;
    white-space: nowrap;
    z-index: 0;
    &:not(:last-of-type) {
        margin-bottom: 8px;
    }
    &::before {
        background-color: ${navigation.bgColorTabActive};
        bottom: 0;
        content: '';
        left: 0;
        opacity: 0;
        position: absolute;
        right: 0;
        top: 0;
        transition: ${easeOpacity};
        z-index: -1;
    }
    &:hover {
        color: ${navigation.txtColorActive};
        cursor: pointer;
        &::before {
            opacity: 1;
        }
        svg {
            fill: ${navigation.txtColorActive};
        }
    }
`;

export const AccountTab = styled('li', { label: 'AccountTab' })`
    display: inline-flex;
    align-items: center;
    margin-right: 8px;
    height: 32px;
    white-space: nowrap;
`;

interface TabPropsType {
    isActive: boolean;
    isCustomerOrTelebetTab?: boolean;
}

export const NonActiveAccountTab = styled('a', { label: 'NonActiveAccountTab' })<TabPropsType>`
    display: flex;
    align-items: center;
    padding: 0 8px;
    text-decoration: none;
    height: 100%;
    background: ${(props): string => props.isActive ? '#f00 !important' : '#fd7171 !important'};
`;

export const TabsNavigationClose = styled('a', { label: 'TabsNavigationClose' })<TabPropsType>`
    display: inline-block;
    padding: 0 8px 0 0 !important;
    text-decoration: none !important;
    background: ${(props): string => props.isActive ? '#f00 !important' : '#fd7171 !important'};
`;

export const CustomerInnerTab = styled('li', { label: 'CustomerInnerTab' })<TabPropsType>`
    display: inline-flex;
    align-items: center;
    height: 30px;
    margin-right: 8px;
    white-space: nowrap;
    background: ${(props): string => props.isActive ? '#a3ccb2' : '#bbb'};
`;

export const CustomerInnerTabLink = styled('a', { label: 'CustomerInnerTabLink' })`
    color: #fff;
    padding: 0 8px !important;
    font-size: 12px;
    text-decoration: none;
    :hover {
        color: #fff;
    }
`;

export const AuditTab = styled('li', { label: 'AuditTab' })<TabPropsType>`
    position: relative;
    padding-right: 32px;
    float: left;
    background: ${(props): string => props.isActive ? '#fff' : 'rgba(0, 0, 0, .1)'};
`;

export const AuditTabLink = styled('a', { label: 'AuditTabLink' })`
    display: block;
    padding: 10px;
    text-decoration: none;
`;

export const AuditTabClose = styled('a', { label: 'AuditTabClose' })`
    position: absolute;
    right: -1px;
    top: 0;
    border-left-color: #00001a;
    margin-left: 10px;
    padding: 10px;
    text-decoration: none;
`;

export const NavigationLinksWrapper = styled('ul', { label: 'NavigationLinksWrapper' })`
    background-color: ${navigation.bgColor};
`;

export const LeftMenuItemTab = styled('li', { label: 'LeftMenuItemTab' })`
    position: relative;
    padding: 8px 8px 0;
    &:last-of-type {
        padding-bottom: 8px;
    }
    &:hover {
        svg {
            fill: ${navigation.txtColorActive};
        }
    }
`;

export const ArrowIconWrapper = styled(ChevronIcon, { label: 'ArrowIconWrapper' })<TabPropsType>`
    bottom: 0;
    fill: ${({ isActive }): string => isActive ? navigation.txtColorActive : navigation.txtColor};
    margin: auto 0;
    position: absolute;
    right: 4px;
    top: 0;
    transition: fill .2s ease;
`;

export const TabsContent = styled('div', { label: 'TabsContent' })``;

export const TabPanel = styled('div', { label: 'TabPanel' })<{ isActive: boolean }>`
    display: ${({ isActive }): string => isActive ? 'block' : 'none'};
`;
